import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { EmailAdminComponent } from './email-admin.component';
import { EmailTemplateDetailsComponent } from './email-template-details/email-template-details.component';
import { EmailTemplatesComponent } from './email-templates/email-templates.component';
import { SendEmailComponent } from './send-email/send-email.component';

import { AuthGuard } from '../../../core/auth/auth.guard';
import { FormGuard } from '../../../shared/guards/form.guard';

const routes: Routes = [
  {
    path: '',
    component: EmailAdminComponent,
    children: [
      {
        path: 'send',
        component: SendEmailComponent,
        canActivate: [AuthGuard],
        canDeactivate: [FormGuard],
      },
      {
        path: 'template',
        component: EmailTemplatesComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'template/edit',
        component: EmailTemplateDetailsComponent,
        canActivate: [AuthGuard],
        canDeactivate: [FormGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EmailAdminRoutingModule {
}
